export { default as LoyaltyTitleWidget } from './loyalty-title-widget';
